import { fork, all } from 'redux-saga/effects';
import watchSaga from './saga';
import { watchApiAction } from './api/watchApiAction';
import watchMaintenanceSaga from './maintenance';
import watchPerformance from './Performance';
import watchReCaptcha from './reCaptcha';
import { watchTrackingSaga } from './tracking';

export function* root() {
  yield all([
    fork(watchApiAction),
    fork(watchSaga),
    fork(watchMaintenanceSaga),
    fork(watchPerformance),
    fork(watchTrackingSaga),
    fork(watchReCaptcha)
  ]);
}
